import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import Pipes from './pipes';

@NgModule({
  imports: [CommonModule],
  declarations: [...Pipes],
  exports: [...Pipes],
})
export class UtilFilePreviewModule {}
